/***
 * 创建人：DR
 * 时间：2019-06-13
 * 描述：
 *      1. 同时支持度分秒或小数格式的数据；
 *      2. 小数格式默认最多保留8位（作为可选参数）；
        3. 经度范围为-180~180，纬度范围为-90~90；
        4. 度分秒格式可支持°'"或°′″（两者的分秒符号不相同）;
        5. 分、秒都应在[0,60)范围内。
 * 更新记录:
    时间：2020年7月31日15:35:29
    描述：34°51′08.5″ (0\d格式通过校验)
 */
import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[wrapAndWeft]',
  providers:[{provide:NG_VALIDATORS,useExisting:forwardRef(()=>wrapAndWeftDirective),multi:true}]
})
export class wrapAndWeftDirective {

    ///判断经度还是纬度,wrap代表经度,weft代表纬度
    @Input('wrapAndWeft')
    wrapOrWeft:any;
    
    //是否判断小数点后保留位数,传递1则表示需要校验，不传或者其他则表示不校验
    @Input('ponintType')
    type:any;

  constructor() { }
  validate(control:AbstractControl):any{
    let valid:boolean = false;
    //默认为经度
    if(this.wrapOrWeft=="weft"){
        //纬度
        let reg1 = /^[\-\+]?(([0-8]?[0-9]°)($|(([0-5]?[0-9]('|′))($|([0-5]?[0-9](\.\d{1,8})?("|″))$))))|(^[\-\+]?90°$)/;
        let reg2 = /^[\-\+]?(([0-9]|([0-8]\d?))(\.\d{1,100})?|90(\.0{1,100})?)$/;
        if(this.type=="1"){
          reg2 = /^[\-\+]?(([0-9]|([0-8]\d?))(\.\d{1,8})?|90(\.0{1,8})?)$/;
        }

        if(!control.value){
          valid = true  //为空时不校验
        } else{
          valid = reg1.test(control.value) ||  reg2.test(control.value) ;  //两者任一通过即可
        }
        return valid ? null:  {wrapAndWeft:"格式错误"}   
    }else{
        //经度
        let reg1 =/^[\-\+]?(((1[0-7])?|[0-9])?[0-9]°)($|(([0-5]?[0-9]('|′))($|(([0-5]?[0-9](\.\d{1,8})?("|″))$))))|(^[\-\+]?180°$)/;
        let reg2 =/^[\-\+]?(0(\.\d{1,10})?|([0-9](\d)?)(\.\d{1,100})?|1[0-7]\d{1}(\.\d{1,100})?|180(\.0{1,100})?)$/;
        if(this.type=="1"){
          reg2=/^[\-\+]?(0(\.\d{1,10})?|([0-9](\d)?)(\.\d{1,8})?|1[0-7]\d{1}(\.\d{1,8})?|180(\.0{1,8})?)$/;
        }

        if(!control.value){
          valid = true  //为空时不校验
        } else{
          valid = reg1.test(control.value) || reg2.test(control.value);  //两者任一通过即可
        }
        return valid ? null:  {wrapAndWeft:"格式错误"}  
    }
  }
}
